import { useMemo } from "react";

function AssetList({ coin, setSideAssets, sideAssets }) {
  const coinKey = coin?.id ?? coin?.symbol;

  const isInSideAssets = useMemo(() => {
    if (!Array.isArray(sideAssets)) return false;
    return sideAssets.some(item => {
      if (typeof item === 'string') return item === coinKey;
      if (item && typeof item === 'object') {
        return (item.id ?? item.symbol) === coinKey;
      }
      return false;
    });
  }, [sideAssets, coinKey]);

  const addToSideAssets = () => {
    setSideAssets(prev => {
      if (!Array.isArray(prev)) return [coin];
      if (prev.some(item => (item.id ?? item.symbol) === coinKey)) return prev;
      return [...prev, coin];
    });
  };

  const removeFromSideAssets = () => {
    setSideAssets(prev => {
      if (!Array.isArray(prev)) return prev;
      return prev.filter(item => {
        if (typeof item === 'string') return item !== coinKey;
        return (item.id ?? item.symbol) !== coinKey;
      });
    });
  };

  return (
    <div
      onClick={isInSideAssets ? removeFromSideAssets : addToSideAssets}
      className="mycard d-flex align-items-center justify-content-center flex-column p-2"
      style={{
        minWidth: '70px',
        minHeight: '60px',
        width: '70px',
        height: '60px',
        border: isInSideAssets ? '1px solid #31acee' : '',
        cursor: 'pointer'
      }}
      title={isInSideAssets ? 'Remove from selected' : 'Add to selected'}
    >
      <img src={coin.logo} alt={coin.symbol} width="25" />
      <p className="mb-0 fw-semibold" style={{ fontSize: '12px' }}>{coin.symbol}</p>
    </div>
  );
}

export default AssetList;